


























import {Component, Vue} from 'vue-property-decorator';
import PlanEditResultEditDialog from '@/views/journals/planEdit/planEditTabs/result/edit/PlanEditResultEditDialog.vue';
import {mapActions, mapState} from 'vuex';
import PlanEditResultModel, {PlanEditResultCurrentConfig} from '@/models/PlanEditResultModel';
@Component({
    components: {PlanEditResultEditDialog},
    computed: {
        ...mapState('planEditResult', ['resultConfigsDescriptions', 'currentConfig', 'result']),
    },
    methods: {
        ...mapActions('planEditResult', ['setResultConfig']),
    },
})
export default class PlanEditResultSettingsMenu extends Vue {
    private menu: boolean = false;
    public resultConfigsDescriptions!: PlanEditResultCurrentConfig[];
    public currentConfig!: PlanEditResultCurrentConfig;
    public result!: PlanEditResultModel;
    public setResultConfig!: Function;

    open() {
        this.menu = true;
    }

    close() {
        this.menu = false;
    }

    async onSelect(id: number) {
        if (this.currentConfig?.Id === id) return;
        this.setResultConfig({idResultConfig: id, idResult: this.result.Id});
    }
}
